module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/4e5f4ef5c476e380a0002716324c2591.png";